import {
  ICD_CODE_CHARACTER_LIMIT,
  DRG_CODE_CHARACTER_LIMIT,
} from "core/schemas/shared";
import { margin, padding } from "ds_legacy/materials/metrics";
import {
  Section,
  SectionRow,
  TextAreaWithLabel,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionOne = () => {
  const translations = useTranslations();

  return (
    <Section title={translations.patientForms.drvMedicalForm.sectionOne.title}>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextAreaWithLabel
          bold
          elementName="main_diagnosis"
          label={
            translations.patientForms.drvMedicalForm.sectionOne
              .descriptionDiagnosis
          }
          marginOverride={margin(0)}
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          characterLimit={ICD_CODE_CHARACTER_LIMIT}
          elementName="icd_code_1_code"
          label={
            translations.patientForms.drvMedicalForm.sectionOne.diagnosisIcd
          }
          large
        />
        <TextInputWithLabel
          bold
          characterLimit={DRG_CODE_CHARACTER_LIMIT}
          elementName="drg_code"
          label={translations.patientForms.drvMedicalForm.sectionOne.drgGroup}
          large
        />
      </SectionRow>
    </Section>
  );
};
